import React, { useState } from "react";
import AppTextField from "../../components/text-field/component";
import AppButton from "../../components/button/component";

const UpdateUserEmail = ({ updateEmailConnect }) => {
  const [email, setEmail] = useState("");
  const [userId, setUserId] = useState("");
  const [status, setStatus] = useState("");
  const [response, setResponse] = useState(null);

  const handleSubmit = async () => {
    if (!userId || !email) {
      setStatus("User ID and Email are required");
      return;
    }

    setStatus("Updating email...");
    let data = {
      userGuid: userId,
      newEmail: email,
      oldEmail: "",
    };

    updateEmailConnect(data)
      .then((res) => {
        setResponse(res);
        if (res) {
          setStatus("Email updated successfully");
        } else {
          setStatus("Failed to update email");
        }
      })
      .catch((error) => {
        console.error("Error updating email:", error);
        setStatus("Failed to update email");
        setResponse(null);
      });
  };

  return (
    <div className="w-full flex justify-center items-center">
      <div className="m-10 w-full flex flex-col gap-4">
        <div className="w-full">
          <h5 className="text-2xl font-semibold"> Update User Email</h5>
          <div className="space-y-4 w-full max-w-xs">
            <AppTextField
              type="text"
              placeholder="User ID"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              className="border rounded p-2"
            />
            <AppTextField
              type="email"
              placeholder="New Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border rounded p-2"
            />
            <AppButton
              type="button"
              onClick={handleSubmit}
              className="bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 text-white"
            >
              Update Email
            </AppButton>
            {status && (
              <p
                className={`${
                  status.includes("success") ? "text-green-500" : "text-red-500"
                }`}
              >
                {status}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateUserEmail;
